import type {
	Choice,
	RenderableItemTypes,
} from "@memorang/types/src/session/new-session";
import AIExplanation from "../components/postanswer/AiExplanation";
import HumanExplanation from "../components/postanswer/HumanExplanation";
import { AI_SUBMITTABLE_VARIANTS } from "../constants";
import useAIFeedbackStore from "../hooks/useAIFeedbackStore";
import useSessionStore from "../hooks/useSessionStore";

type Props = {
	itemId: number;
	itemType: RenderableItemTypes;
	choices: Choice[];
};
const ExplanationContainer = ({ itemId, itemType, choices }: Props) => {
	const aiResponse = useAIFeedbackStore((state) => state.aiResponse);
	const streaming = useAIFeedbackStore((state) => state.streaming);
	const itemState = useSessionStore((state) => state.itemStates?.get(itemId));
	const activeChoiceId =
		itemType === "BINARY_CHOICE"
			? (itemState?.previewChoiceId ?? itemState?.selectedChoiceIds?.[0])
			: undefined;

	if (itemType === "EXPLORE_ACCORDION") {
		return null;
	}

	const isAiItemType = AI_SUBMITTABLE_VARIANTS.includes(itemType);

	const currentItemAiResponse = aiResponse?.[itemId];

	if (isAiItemType) {
		return (
			<AIExplanation
				aiResponse={currentItemAiResponse?.explanation}
				loading={streaming}
				itemId={itemId}
			/>
		);
	}

	return (
		<HumanExplanation
			choices={choices}
			itemId={itemId}
			activeChoiceId={activeChoiceId}
		/>
	);
};

export default ExplanationContainer;
